import { useTranslation } from 'react-i18next'
import { Text, Badge, Box, IconCheckCircleOutline } from '@machobear/design-system'
import { InsightBlock } from '../insight-block'

export const PendingVerificationByDocument = () => {
  const { t } = useTranslation()

  return (
    <InsightBlock
      testId="verify-listing"
      icon={<IconCheckCircleOutline tone="positive" size="small" />}
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="flexStart"
        alignItems="center"
        gap="xxsmall"
        style={{ height: '21px' }}
      >
        <Text size="medium" weight="medium">
          {t('Verify your listing')}
        </Text>
        <Badge tone="caution">{t('IN PROGRESS')}</Badge>
      </Box>
    </InsightBlock>
  )
}
